import styled from 'styled-components'
import { Panel as BasePanel } from '../../ui'

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1020;
  pointer-events: none;
`

export const Panel = styled(BasePanel)`
  background: ${({ theme }) => theme.colors('background', 0.92)};
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.45)};
  padding: 1.5rem 2rem;
  min-width: unset;
  text-align: center;
  pointer-events: all;
`

export const Title = styled.div`
  font-size: 0.7rem;
  color: ${({ theme }) => theme.colors('foreground', 0.45)};
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const Buttons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`

export const ChoiceButton = styled.button`
  background: ${({ theme }) => theme.colors('highlight', 0.2)};
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.45)};
  color: ${({ theme }) => theme.colors('text')};
  font-family: 'Silkscreen', monospace;
  font-size: 0.85rem;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  &:hover { background: ${({ theme }) => theme.colors('highlight', 0.4)}; }
`

export const DismissButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors('foreground', 0.45)};
  font-family: 'Silkscreen', monospace;
  font-size: 0.7rem;
  margin-top: 1rem;
  cursor: pointer;
  padding: 0;
  &:hover { color: ${({ theme }) => theme.colors('text')}; }
`
